import { transformDTODate } from '@skylab-shared/core';
import { Transform } from 'class-transformer';
import { EmailDeliveryStatusCode } from './email-delivery-status-code';
import { EmailDeliveryStatusCodeSeverity } from './email-delivery-status-code-severity';

export class EmailDeliveryStatus {
    public recipient: string;
    public status: EmailDeliveryStatusCode;
    public severity?: EmailDeliveryStatusCodeSeverity;
    public description?: string;
    @Transform(transformDTODate, { toClassOnly: true }) public readonly updatedAt: Date;
};
